































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import '@/compiled-icons/file-pdf-outline';
import '@/compiled-icons/paperclip';
import '@/compiled-icons/microsoft-excel';
import '@/compiled-icons/microsoft-word';
import '@/compiled-icons/microsoft-powerpoint';
import '@/compiled-icons/image';
import '@/compiled-icons/download';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {DisguiseBusinessExceptionWrapper} from '../../exception/disguise-business-exception-wrapper';
import AdvancedConfirmDialog, {ConfirmationDialogButton, ConfirmationDialogConfig} from '@/views/AdvancedConfirmDialog.vue';

/**
 * General Component for Fields of type ATTACHMENT
 */
@Component({
    components: {AdvancedConfirmDialog}
})
export default class AmetrasAttachmentTemplate extends Vue {
    @Prop() marginDefinition!: string;
    @Prop() paddingDefinition!: string;
    @Prop() value!: string;
    convertedValue!: DisguiseDto.AttachmentDto;
    downloadAllAsZipUrl: string = '';
    confirmationDialogConfig: ConfirmationDialogConfig | null = null;

    created() {
        this.convertedValue = JSON.parse(this.value);
        this.buildZipUrl();
    }

    @Watch('value') valueChanged(newValue: boolean) {
        this.convertedValue = JSON.parse(this.value);
        this.buildZipUrl();
    }

    @Watch('convertedValue') innerValueChanged(newValue: boolean) {
        this.$emit('input', newValue);
    }

    buildZipUrl() {
        if (this.convertedValue && this.convertedValue.files && this.convertedValue.files.length > 0) {
            const filesToBeDownloaded = [];
            for (const currentAttachment of this.convertedValue.files) {
                filesToBeDownloaded.push(currentAttachment.uuid);
            }
            if (filesToBeDownloaded && filesToBeDownloaded.length > 0) {
                this.downloadAllAsZipUrl = (this.convertedValue.zipPath || '') + filesToBeDownloaded.join(',');
            } else {
                this.downloadAllAsZipUrl = '';
            }
        } else {
            this.downloadAllAsZipUrl = '';
        }
    }

    deleteFile(fileUpload: DisguiseDto.FileUploadDto, event: Event) {
        event.preventDefault();
        this.confirmationDialogConfig = {
            title: 'Bestätigen',
            headerColor: 'primary',
            message: `Möchten Sie den Anhang \'${fileUpload.fileName}\' wirklich löschen?`,
            buttons: [{
                text: 'Bestätigen',
                title: 'Bestätigen',
                disabled: false,
                loading: false,
                autoFocus: true,
                onClick: (button: ConfirmationDialogButton) => {
                    button.disabled = true;
                    button.loading = true;
                    HTTP_SERVICE_INSTANCE.getAxios().delete(
                        (this.convertedValue.deletePath || '') + fileUpload.uuid
                    ).then(() => {
                        this.$store.commit('showSnack', {
                            message: `\'${fileUpload.fileName}\' wurde gelöscht.`,
                            color: 'success'
                        });
                        this.confirmationDialogConfig = null;
                        this.$emit('afterUploadDeleted');
                    }, (error) => {
                        if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
                            this.$store.commit('showSnack', {
                                message: `Löschen der Datei \'${fileUpload.fileName}\' fehlgeschlagen`,
                                color: 'error'
                            });
                        }
                        button.disabled = false;
                        button.loading = false;
                    });
                }
            }, {
                text: 'Abbrechen',
                title: 'Abbrechen',
                disabled: false,
                loading: false,
                onClick: () => {
                    this.confirmationDialogConfig = null;
                }
            }],
            onEsc: () => {
                this.confirmationDialogConfig = null;
            }
        };
    }

}
